import { contentSummary } from "../../types/contentSummary";
import ArticleLink from "../molecules/ArticleLink";
import STNews from "../../assets/styles/organisms/news.module.scss";
import { useEffect, useState } from "react";
import {
  fetchContents,
  TApiContentsResult,
} from "../../utils/api/fetchContents";
import { CONTENT_TYPE } from "../../types/TAppContentType";
import TApiResult from "../../types/api/TApiResult";
import { getSubdomain } from "../../utils/getSubdomain";
import { useHistory } from "react-router-dom";
import { routes } from "../../router/Router";
import PAGE_CONFIG from "../../config/page";

const News: React.FC = () => {
  const subdomain = getSubdomain(window.location.hostname);
  const [news, setNews] = useState<contentSummary[]>([]);
  const history = useHistory();

  useEffect(() => {
    fetchContents(0, 3, [CONTENT_TYPE.news]).then(
      (res: TApiResult & TApiContentsResult) => {
        if (!res.isSuccess || !res.result)
          return history.push(routes.error.path);
        const newNews: contentSummary[] = res.result.contents.map((res) => {
          return {
            id: res.id,
            title: res.title,
            createdAt: res.post_date,
            linkUrl: `news/${res.id}`,
            imageUrl: res.img_url,
            goodCount: res.like_count,
          };
        });
        setNews(newNews);
      }
    );
  }, []);

  return (
    <section className={STNews.news}>
      <div
        className={`${STNews.news_title} ${PAGE_CONFIG.STATIC_CLASSES.SUBJECT}`}
      >
        お知らせ
      </div>
      <div className="newsList">
        {news.map((article) => (
          <ArticleLink
            key={article.id}
            articleSummary={article}
            className="top-newsArticle"
            subdomain={subdomain}
          />
        ))}
      </div>
    </section>
  );
};

export default News;
